import { Link } from "react-router-dom";

interface ChoreographyCardProps {
  to: string;
  title: string;
}

function ChoreographyCard({ to, title }: ChoreographyCardProps) {
  return (
    <li>
      <Link
        to={to}
        style={{
          display: "block",
          textDecoration: "none",
          color: "#333",
          padding: "20px",
          border: "1px solid #333",
          borderRadius: "8px",
          backgroundColor: "#f8f9fa",
          textAlign: "center",
          transition: "all 0.3s ease",
          fontSize: "1.1rem",
          fontWeight: "500",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#333";
          e.currentTarget.style.color = "white";
          e.currentTarget.style.transform = "translateY(-2px)";
          e.currentTarget.style.boxShadow =
            "0 4px 8px rgba(212, 212, 212, 0.3)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#f8f9fa";
          e.currentTarget.style.color = "#333";
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "none";
        }}
      >
        {title}
      </Link>
    </li>
  );
}

interface Choreography {
  to: string;
  title: string;
}

interface YearSectionProps {
  year: string;
  choreographies: Choreography[];
}

function YearSection({ year, choreographies }: YearSectionProps) {
  return (
    <div style={{ marginBottom: "30px" }}>
      <h3
        style={{
          color: "#555",
          fontSize: "1.4rem",
          marginBottom: "15px",
          paddingBottom: "8px",
          borderBottom: "1px solid lightgray",
          fontWeight: "600",
        }}
      >
        {year}
      </h3>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: "20px",
          justifyContent: "start",
        }}
      >
        {choreographies.map((choreography, index) => (
          <ChoreographyCard
            key={index}
            to={choreography.to}
            title={choreography.title}
          />
        ))}
      </ul>
    </div>
  );
}

export default YearSection;
